export function getAllowedMinutesAfterThreshold({
  threshold,
  step,
}: {
  threshold: number;
  step: number;
}) {
  for (let minutes = 0; minutes <= 60; minutes += step) {
    if (minutes > threshold) {
      return minutes;
    }
  }

  return 0;
}
